import ActionConstants from '../constants/ActionConstants';

/**
 * Sets the current page header used by the app shell: the web top-bar title and
 * the mobile breadcrumb trail + back control.
 *
 * @param {Object} payload
 * @param {string} payload.title current page name
 * @param {Array<{label: string, path: string}>} [payload.crumbs] breadcrumb trail; last item is the current page
 * @param {boolean} [payload.showBack] whether the mobile back arrow is shown
 * @param {{content: string}} [payload.titleInfo] optional help popover shown as a "?" next to the title (content is an i18n id)
 * @param {boolean} [payload.ariesLayout] opt the content container into the Aries redesign page surface (`aries-page-bg`); set by redesigned views so the shell background matches the redesign and the mobile sticky header band
 */
export const setPageHeader = ({
  title = '',
  crumbs = [],
  showBack = false,
  titleInfo = null,
  ariesLayout = false,
}) => ({
  type: ActionConstants.SET_PAGE_HEADER,
  payload: { title, crumbs, showBack, titleInfo, ariesLayout },
});

export const clearPageHeader = () => ({
  type: ActionConstants.CLEAR_PAGE_HEADER,
});
